import { FC, ReactNode } from "react";
import { useRecoilValue } from "recoil";
import { IfBlock } from "../components/IfBlock";
import { isShowPointState } from "../stores";

export const IfShowPoint: FC<{
    children: ReactNode
}> = ({ children }) => {
    const visible = useRecoilValue(isShowPointState);
    return <IfBlock visible={visible}>{children}</IfBlock>
}
